import { Button, Card } from '@blueprintjs/core';

import cls from './Filter.module.css';

interface FilterInfoCardProps {
  className?: string;
  completedTotal: number;
  onReset: () => void;
  areFiltersInitial: boolean;
}
export function FilterInfoCard({ className, completedTotal, onReset, areFiltersInitial }: FilterInfoCardProps) {
  return (
    <Card className={className}>
      <div className={cls.filterInfo}>
        <div>
          <span className={cls.bold}>{completedTotal}</span>
          <span>{` result${completedTotal !== 1 ? 's' : ''} match${completedTotal !== 1 ? '' : 'es'} filters`}</span>
        </div>
        <Button minimal text="Reset filters" icon="reset" onClick={onReset} disabled={areFiltersInitial} />
      </div>
    </Card>
  );
}
